import FolderListDetail from '../components/detail/folder-list-detail';
import { PropTypes } from 'base/react-libs';
import { useFolderDetails } from '../hooks/use-folder-details';

const FolderController = ({ id }) => {
  const folderDetails = useFolderDetails(id);

  return <FolderListDetail id={id} {...folderDetails} />;
};

FolderController.propTypes = {
  id: PropTypes.string.isRequired,
};

export default FolderController;
